import React from "react";
import styles from "./InfoCard.module.scss";
import useMegatron from "../../../../hooks/useMegatron";

interface InfoCardProps {
  readonly mainText?: string;
  readonly bulletPoints?: string[];
  readonly Message?: string[];
  readonly headerText?: string
}

const InfoCard = ({
  headerText = "",
  mainText = "You can search by:",
  bulletPoints,
  Message,
}: InfoCardProps) => {
  return (
    <>
      <div className={styles.infoCard}>
        <h1 className={styles.headerText}>{headerText}</h1>
        <p>{mainText}</p>
        {bulletPoints?.map((text, index) => (
          <p key={text}>
            <span className="dot">{index + 1}</span> {text}
          </p>
        ))}
        <p>{Message}</p>
      </div>
    </>
  );
};

export default InfoCard;
